export default __webpack_public_path__ + "media/images/features/yado/message_about-d984e721007f67f258292a784c6b18d2.png";